import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'

import { LoadingButton } from '../../../../components'

const ReturnTermDialog = ({
  open,
  loading,
  schoolName,
  shiftName,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={loading ? undefined : onCancel} disableRestoreFocus>
    <DialogTitle>Retornar à lista de suplência</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Estou ciente de que esta ação é irreversível e desejo retornar à
        lista de suplência da escola {schoolName}, no turno {shiftName}.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>
        Cancelar
      </Button>
      <LoadingButton onClick={onConfirm} disabled={loading} loading={loading}>
        Confirmar retorno
      </LoadingButton>
    </DialogActions>
  </Dialog>
)

export default ReturnTermDialog
